export default __webpack_public_path__ + "static/media/phone.f639c73c.png";